/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'FlexCard',
  props: {
    item: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  methods: {
    editItem: function editItem(item) {
      if (this.$parent.$parent.isShowList) {
        // 说明是问题管理模块里面的 可以编辑  其余的是选择
        this.$router.push({
          path: '/order/addProblemList',
          query: {
            id: item.id
          }
        });
      }
    }
  }
};